import { RewardRulesConfigurationResponse, RewardRulesConfigurationResult } from './getRewardRulesConfiguration.types'
import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

const NOT_CONFIGURED: RewardRulesConfigurationResult = { status: 'none', configuration: null }

export const getRewardRulesConfiguration: QueryFn<
  ['getRewardRulesConfiguration'],
  RewardRulesConfigurationResult
> = async client => {
  const { data, status } = await client.get<RewardRulesConfigurationResponse>(
    'v1/partner/gamification/reward-rules-configuration',
    { validateStatus: code => [200, 403].includes(code) }
  )

  return (status === 200 ? data.data : undefined) ?? NOT_CONFIGURED
}
